<script lang="ts">
	import { Button, ButtonType } from '@repo/commons/components'
	import type { TableData } from '@repo/commons/models'

	interface Props {
		row: TableData
		onEdit?: (row: TableData) => void
		onDelete?: (row: TableData) => void
		disabled?: boolean
	}

	let { row, onEdit, onDelete, disabled }: Props = $props()
</script>

<div class="flex items-center gap-2">
	{#if onEdit}
		<Button
			buttonText=""
			buttonType={ButtonType.TERTIARY_INVERSE}
			iconProps={{ name: 'edit', size: 'md', class: 'text-[#002C4D80]' }}
			onclick={() => onEdit?.(row)}
			rounded
			{disabled}
		/>
	{/if}
	{#if onDelete}
		<Button
			buttonText=""
			buttonType={ButtonType.TERTIARY_INVERSE}
			iconProps={{ name: 'trash', size: 'md', class: 'text-[#002C4D80]' }}
			onclick={() => onDelete?.(row)}
			rounded
			{disabled}
		/>
	{/if}
</div>
